/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize ProteinEnergeticWear List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './ProteinEnergeticWearListView';

export const mapStateToPropsProteinEnergeticWearList = mapStateToProps;
export const mapDispatchToPropsProteinEnergeticWearList = mapDispatchToProps;

export default connect(
  mapStateToPropsProteinEnergeticWearList,
  mapDispatchToPropsProteinEnergeticWearList
)(View);
